module.exports = __webpack_public_path__ + "static/img/study_report_official.51f55742.png";